<template>
  <v-row no-gutters style="position: relative; height: 100%;">


    <v-col cols="12" style="position: relative;">
        <v-col cols="12 text-center"  v-if="form_step">
          <iframe :src="video_object[this.step]" width="100%" height="290" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
        </v-col>
      <v-row no-gutters style="height: 100%;">
        <v-col 
          cols="12"
        >
          <v-row no-gutters>
            <v-col class="text-end">
              <v-btn color="primary" @click="sendClientLink" >Send Client Link</v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="flex-column" style="height: 100%;">
            
            <v-col class="mb-4 text-center flex-shrink-1 flex-grow-0" v-if="this.tab != 'onboarding'">

              <div class="title" style="min-height: 35px; height: 35px;">
                <span v-if="household.spouse">
                  <span v-if="household.spouse.last_name == household.user.last_name">
                    {{ household.user.first_name }} and {{ household.spouse.full_name }}
                  </span>
                  <span v-else>
                    {{ household.user.full_name }} and {{ household.spouse.full_name }}
                  </span>
                </span>
                <span v-else-if="household.user">
                  {{ household.user.full_name }}
                </span>
                &nbsp;
              </div>
            </v-col>
            <v-col class="flex-shrink-1 flex-grow-0" v-if="this.tab != 'onboarding'">
              <v-tabs
                icons-and-text
                centered
                height="120"
              >
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#prd-freedom-accelerator" class="householdTab" :to="{name: 'households-prd-freedom-accelerator'}">
                  <div class="householdTabText">Freedom Accelerator</div>
                  <v-icon x-large class="householdTabIcon">mdi-finance</v-icon>
                </v-tab>

                <v-tab href="#debts" class="householdTab nonProduct" :to="{name: 'households-debts'}">
                  <div class="householdTabText">Liabilities</div>
                  <v-icon x-large class="householdTabIcon">mdi-sack</v-icon>
                </v-tab>

                <v-tab href="#policies" class="householdTab nonProduct" :to="{name: 'households-policies'}">
                  <div class="householdTabText">Policies</div>
                  <v-icon x-large class="householdTabIcon">mdi-file-document-edit</v-icon>
                </v-tab>
                <v-tab href="#settings" class="householdTab nonProduct" :to="{name: 'households-settings'}">
                  <div class="householdTabText">Settings</div>
                  <v-icon x-large class="householdTabIcon">mdi-cog</v-icon>
                </v-tab>

                <!--<v-btn text class="householdTabButton" color="grey darken-1">
                  <v-icon x-large>mdi-plus</v-icon>
                </v-btn>-->
              </v-tabs>
            </v-col>
            <v-col v-if="loading" class="text-center pa-6">
              <v-progress-circular
                :size="40"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-col>
            <v-col v-else>
              <v-tabs-items v-model="tab" style="height: 100%;">
                <v-tab-item
                  value="onboarding"
                  transition="fade-up"
                  reverse-transition="fade-up"
                  style="height: 100%;"
                >
                  <onboarding-index 
                    :household="household" 
                    @on-debt-updated="updateDebt" 
                    @on-debt-deleted="deleteDebt" 
                    @on-intake-updated="updateIntake"
                    @form-step="getFormStep"
                  />
                </v-tab-item>
                <v-tab-item
                  value="settings"
                  transition="fade-up"
                  reverse-transition="fade-up"
                  style="height: 100%;"
                >
                  <settings
                    :household="household"
                    @on-intake-updated="updateIntake"
                  />
                </v-tab-item>
                <v-tab-item
                  value="prd-freedom-accelerator"
                  transition="fade-up"
                  reverse-transition="fade-up"
                  style="height: 100%;"
                >  
                  <freedom-accelerator-index 
                    :household="household" 
                    :plan="plan"
                    :plans="plans"
                    key="prd-fa-index" 
                    @on-update-intake="updateIntakeSummary"
                    @on-policy-updated="updatePolicy"
                    @on-debt-updated="updateDebt"
                    @on-plan-updated="updatePlan"
                    @on-plan-status-updated="updatePlanStatus"
                  />
                </v-tab-item>
                <v-tab-item
                  value="debts"
                  transition="fade-up"
                  reverse-transition="fade-up"
                  style="height: 100%;"
                >
                  <debts-index :household="household" @on-debt-updated="updateDebt" @on-debt-deleted="deleteDebt" @on-plans-altered="onPlansAltered" />
                </v-tab-item>
                <v-tab-item
                  value="policies"
                  transition="fade-up"
                  reverse-transition="fade-up"
                  style="height: 100%;"
                >
                  <policies-index :household="household" @on-policy-updated="updatePolicy" @on-policy-deleted="deletePolicy" @on-plans-altered="onPlansAltered" />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>

    <div style="position: absolute; bottom: -15px; left: 5px;">
      <v-btn v-show="showAdvancedButton" color="grey lighten-2" small text @click="advancedSettingsDialog = true"><v-icon small>mdi-information-outline</v-icon></v-btn>
    </div>
  </v-row>
</template>

<script>
import OnboardingIndex from '@/views/households/onboarding/Index'
import DebtsIndex from '@/views/households/liabilities/Index'
import PoliciesIndex from '@/views/households/policies/Index'
import FreedomAcceleratorIndex from '@/views/households/freedom-accelerator/Index'
import Settings from '@/views/households/Settings'
/*import DebtView from '@/views/households/debts/DebtView'
import PolicyView from '@/views/households/policies/PolicyView'
import Overview from '@/views/households/overview/Overview'
import MortgageEnhancer from '@/views/households/mortgage-enhancer/MortgageEnhancerView'
import UserSearchField from '@/components/UserSearchField'*/

export default {
  name: 'HouseholdsView',
  components: {
    OnboardingIndex,
    DebtsIndex,
    PoliciesIndex,
    FreedomAcceleratorIndex,
    Settings
    /*DebtView,
    PolicyView,
    Overview,
    MortgageEnhancer,
    UserSearchField*/
  },
  data: () => ({
    loading: true,
    tab: null,
    household: {},
    refetchMortgageEnhancerPlan: false,
    mortgageEnhancerPlan: null,
    refetchPlan: false,
    plan: null,
    plans: [],
    minPlan: null,
    settingsDialog: false,
    advancedSettingsDialog: false,
    savingHousehold: false,
    newUser: null,
    newUserIncome: null,
    newSpouse: null,
    newSpouseIncome: null,
    newThreshold: null,
    newDesiredMonthlyCap: null,
    newDesiredOutcomes: [null,null,null,null,null],
    newPreparedBy: null,
    newPreparedByEmail: null,
    newPreparedByTitle: null,
    newDebtAlgorithm: 'balance_low_high',
    newAdditionalLoanPrincipal: 0,
    newShowBenefits: true,
    debtAlgorithms: [
      {
        text: 'Lowest Balance First',
        value: 'balance_low_high'
      },
      {
        text: 'Highest Interest Rate First',
        value: 'interest_high_low'
      }
    ],
    expansions: 'user,spouse,debts,debts.amortizationSchedule,policies,plans,encrypted_id,user.agent',

    showAdvancedButton: false,
    video_object : {
      1: 'https://player.vimeo.com/video/816684540?h=3ff980956e',
      2: 'https://player.vimeo.com/video/816684232?h=a188c84a4f',
      3: 'https://player.vimeo.com/video/816684295?h=1854f5af15',
      4: 'https://player.vimeo.com/video/816684382?h=58b53e8ab7',
      5: 'https://player.vimeo.com/video/816684627?h=46df853dd3',
      6: 'https://player.vimeo.com/video/816684212?h=5fc4587104',
      7: 'https://player.vimeo.com/video/816684261?h=7e7c7aed17',
      8: 'https://player.vimeo.com/video/816684477?h=905207d1e1',
      9: 'https://player.vimeo.com/video/816684817?h=cdc116a1f4',
    },
    form_step : null,
    step : 1
  }),
  watch: {
    householdId(newVal) {
      if(newVal) this.getDataFromApi()
    },
    $route: {
      handler (to) {
        this.checkRoute()
        if(to.name == 'households-mortgage-enhancer' && this.refetchMortgageEnhancerPlan) {
          this.getMortgageEnhancerPlanFromApi()
        }
      },
      deep: true
    },
  },
  mounted() {
    this.getDataFromApi()
    this.checkRoute()
    this.refetchMortgageEnhancerPlan = true

    document.addEventListener('keydown', this.keyCheck)
    document.addEventListener('keyup', this.keyCheck)
  },
  beforeDestroy() {
    document.removeEventListener('keydown',this.keyCheck)
    document.removeEventListener('keyup',this.keyCheck)
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    householdId() {
      return this.$route.params.household_id
    },
    hasAMortgageAndPolicy() {
      if(!this.household || !this.household.debts || !this.household.policies) return false
      let hasMortgage = false
      let hasActivePolicy = false

      for(let i = 0; i < this.household.debts.length; i++) {
        if(this.household.debts[i].type == 'mortgage') {
          hasMortgage = true
          break
        }
      }

      for(let i = 0; i < this.household.policies.length; i++) {
        if(this.household.policies[i].default) {
          hasActivePolicy = true
          break
        }
      }

      return (hasMortgage && hasActivePolicy)
    },
    showMortgageEnhancer () {
      if(!this.hasAMortgageAndPolicy) return false
      switch(this.user.id) {
        case 1:
        case 6:
        case 8:
          return true
        default:
          return false
      }
    }
  },
  methods: {
    getFormStep(step){
      if(step && step > 0){
        this.form_step = true;
        this.step = step;
      }
    },

    sendClientLink(){
      if(this.newUser.id){
        this.$http.post('household-customer-data/send-email',  {id:this.newUser.id, email: this.user.email})
            .then(() => {
              this.$swal.fire({
                title: 'Email is send',
                icon: 'success',
                showCancelButton: false,
                showConfirmButton: true
              })
            })
            .catch(() => {
              this.$swal.fire('Error', 'Email is not send')
              this.$router.go(-1)
            })
      }
    },
    checkRoute() {
      if(this.$route.name == 'households-onboarding') {
        this.tab = 'onboarding'
      } else if(this.$route.name == 'households-settings') {
        this.tab = 'settings'
      } else if(this.$route.name == 'households-prd-freedom-accelerator') {
        this.tab = 'prd-freedom-accelerator'
      } else if (this.$route.name == 'households-debts') {
        this.tab = 'debts'
      } else if(this.$route.name == 'households-policies') {
        this.tab = 'policies'
      } else {
        this.$router.replace({name: 'households-prd-freedom-accelerator', params: {household_id: this.householdId }})
      }
    },
    getDataFromApi() {
      this.loading = true;
      this.$http.get('households/' + this.householdId + '?expand=' + this.expansions)
        .then(response => {
          this.plans                        = response.data.plans
          response.data.plans.forEach(p => {
            if(p.default) this.plan = JSON.parse(JSON.stringify(p))
          })
          delete response.data.plans;
          this.household                    = response.data
          this.newThreshold                 = response.data.plan_threshold
          this.newDesiredMonthlyCap         = response.data.desired_monthly_cap
          let arr                           = response.data.desired_outcomes.split("\n")
          while(arr.length < 5) {
            arr.push(null)
          }
          this.newDesiredOutcomes           = arr
          this.newPreparedBy                = response.data.prepared_by
          this.newPreparedByTitle           = response.data.prepared_by_title
          this.newPreparedByEmail           = response.data.prepared_by_email
          this.newUser                      = response.data.user
          this.newSpouse                    = response.data.spouse
          this.newUserIncome                = response.data.user_income_monthly
          this.newSpouseIncome              = response.data.spouse_income_monthly
          this.newDebtAlgorithm             = response.data.plan_algorithm
          this.newAdditionalLoanPrincipal   = response.data.plan_addl_policy_replenishment
          this.newShowBenefits              = (response.data.plan_show_benefits ? true : false)

          if(this.$route.name != 'households-onboarding' && response.data.intake_step !== null) {
            this.$router.replace({name: 'households-onboarding'})
          } else if(this.$route.name === 'households-onboarding' && !response.data.intake_step) {
            this.$router.replace({name: 'households-prd-freedom-accelerator', params: {household_id: this.householdId }})
          }
          /*if(this.refetchMortgageEnhancerPlan && this.$route.name == 'households-mortgage-enhancer') {
            if(this.hasAMortgageAndPolicy) {
              this.getMortgageEnhancerPlanFromApi()
            } else {
              this.$router.replace({name: 'households-view', params:{ household_id: this.householdId }})
            }
          }*/
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error loading Household ID ' + this.householdId, 'error')
          this.$router.go(-1)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPlanFromApi() {
      this.loading = true;
      this.$http.get('households/' + this.householdId + '?expand=plan&fields=plan')
        .then(response => {
          this.plan         = response.data.plan
          //this.refetchPlan  = false
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error regenerating the plan', 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
    getMortgageEnhancerPlanFromApi() {
      this.loading = true;
      this.$http.get('households/' + this.householdId + '/mortgage-enhancer')
        .then(response => {
          this.mortgageEnhancerPlan         = response.data
          this.refetchMortgageEnhancerPlan  = false
        })
        .catch(() => {
          this.$swal.fire('Error', 'There was an error regenerating the mortgage enhancer plan', 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveHousehold() {
      if(!this.newUser || !this.newUser.id) {
        this.$swal.fire('Homeowner Required', 'A Homeowner is required and can not be blank', 'error')
        return
      }
      this.savingHousehold = true

      let uIncome = (this.newUserIncome ? this.newUserIncome : 0)
      let sIncome = (this.newSpouse && this.newSpouse.id ? this.newSpouseIncome : 0)
      if(!sIncome) sIncome = 0

      let desired_outcomes_arr = []
      for(let i = 0; i < this.newDesiredOutcomes.length; i++) {
        if(i > 4) break;
        if(this.newDesiredOutcomes[i]) desired_outcomes_arr.push(this.newDesiredOutcomes[i])
      }

      let data = {
        plan_threshold: this.newThreshold,
        desired_monthly_cap: this.newDesiredMonthlyCap,
        desired_outcomes: desired_outcomes_arr.join("\n"),
        prepared_by: this.newPreparedBy,
        prepared_by_title: this.newPreparedByTitle,
        prepared_by_email: this.newPreparedByEmail,
        spouse_id: (this.newSpouse ? this.newSpouse.id : null),
        spouse_income_monthly: sIncome,
        user_id: this.newUser.id,
        user_income_monthly: uIncome,
        plan_algorithm: (this.newDebtAlgorithm ? this.newDebtAlgorithm : 'balance_low_high'),
        plan_addl_policy_replenishment: (this.newAdditionalLoanPrincipal ? this.newAdditionalLoanPrincipal : 0),
        plan_show_benefits: (this.newShowBenefits ? 1 : 0)
      }
      this.$http.put('households/' + this.householdId + '?expand=' + this.expansions, data)
        .then(response => {
          this.plan                 = JSON.parse(JSON.stringify(response.data.plan))
          delete response.data.plan
          this.household                      = response.data
          this.newThreshold                   = response.data.plan_threshold
          this.newDesiredMonthlyCap           = response.data.desired_monthly_cap
          let arr                             = response.data.desired_outcomes.split("\n")
          while(arr.length < 5) {
            arr.push(null)
          }
          this.newDesiredOutcomes             = arr
          this.newPreparedBy                  = response.data.prepared_by
          this.newPreparedByTitle             = response.data.prepared_by_title
          this.newPreparedByEmail             = response.data.prepared_by_email
          this.settingsDialog                 = false
          this.advancedSettingsDialog         = false
          this.newUser                        = response.data.user
          this.newSpouse                      = response.data.spouse
          this.newUserIncome                  = response.data.user_income_monthly
          this.newSpouseIncome                = response.data.spouse_income_monthly
          this.newDebtAlgorithm               = response.data.plan_algorithm
          this.plan_addl_policy_replenishment = response.data.plan_additional_principal
          this.newShowBenefits                = (response.data.plan_show_benefits ? true : false)
        })
        .catch(() => {
          this.$swal.fire('Error', 'There wasn an error updating the household', 'error')
        })
        .finally(() => {
          this.savingHousehold = false
        })
    },
    updateDebt ( debt ) {
      //this.refetchPlan = true
      this.refetchMortgageEnhancerPlan = true
      let found = null
      for(let i = 0; i < this.household.debts.length; i++) {
        if(this.household.debts[i].id == debt.id) {
          found = i;
          break;
        }
      }

      if(found !== null) {
        this.$set(this.household.debts, found, debt)
      } else {
        this.household.debts.push(debt);
      }
    },
    updatePolicy ( policy ) {
      //this.refetchPlan = true
      this.refetchMortgageEnhancerPlan = true
      let found = null
      for(let i = 0; i < this.household.policies.length; i++) {
        if(this.household.policies[i].id == policy.id) {
          found = i;
          break;
        }
      }

      if(found !== null) {
        this.$set(this.household.policies, found, policy)
      } else {
        this.household.policies.push(policy);
      }
    },
    deleteDebt (debt) {
      this.$swal.fire({
        title: 'Are you sure?',
        html: 'Please confirm that you want to remove<br><b>' + debt.name + ' - $' + parseFloat(debt.balance).toLocaleString(undefined, {maximumFractionDigits:2}) + '</b>',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        preConfirm: () => {
          this.$swal.update({showCancelButton: false});
          this.$http.delete('debts/' + debt.id)
            .finally(() => {
              for(let i = 0; i < this.household.debts.length; i++) {
                if(this.household.debts[i].id == debt.id) {
                  this.household.debts.splice(i, 1)
                  break
                }
              }
              return {}
            })
        }
      })
    },
    deletePolicy (policy) {
      this.$swal.fire({
        title: 'Are you sure?',
        html: 'Please confirm that you want to remove<br><b>' + policy.name + '</b>',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        preConfirm: () => {
          this.$swal.update({showCancelButton: false});
          this.$http.delete('policies/' + policy.id)
            .finally(() => {
              for(let i = 0; i < this.household.policies.length; i++) {
                if(this.household.policies[i].id == policy.id) {
                  this.household.policies.splice(i, 1)
                  break
                }
              }
              return {}
            })
        }
      })
    },

    keyCheck (e) {
      if(e.shiftKey) {
        this.showAdvancedButton = true
      } else {
        this.showAdvancedButton = false
      }
    },

    updateIntake(data) {
      this.$set(this.household, 'user_id', data.user_id)
      this.$set(this.household, 'user', data.user)
      this.$set(this.household, 'spouse_id', data.spouse_id)
      this.$set(this.household, 'spouse', data.spouse)
      this.$set(this.household, 'intake', data.intake)
      this.$set(this.household, 'intake_step', data.intake_step)
      this.$set(this.household, 'prepared_by', data.prepared_by)
      this.$set(this.household, 'prepared_by_title', data.prepared_by_title)
      this.$set(this.household, 'prepared_by_email', data.prepared_by_email)
      this.plans = data.plans
      data.plans.forEach(p => {
        if(p.default) this.plan = JSON.parse(JSON.stringify(p))
      })
    },
    updateIntakeSummary(data) {
      this.$set(this.household, 'intake', data.intake)
      this.$set(this.household, 'desired_monthly_cap', data.desired_monthly_cap)
    },
    updatePlan(plan) {
      let exists = null
      for(let i = 0; i < this.plans.length; i++) {
        if(this.plans[i].id == plan.id) {
          exists = i
          break
        }
      }

      if(exists !== null) {
        if(plan.default && !this.plans[exists].default) this.clearActiveStatusOnPlans()
        this.$set(this.plans, exists, plan)
      } else {
        if(plan.default) this.clearActiveStatusOnPlans()
        if(plan.status == 'ACTIVE' && plan.previous_id) {
          if(this.plans.length == 1) {
            this.$set(this.plans[0], 'status','ORIGINAL')
          } else {
            for(let i = 0; i < this.plans.length; i++) {
              if(this.plans[i].id == plan.previous_id) this.$set(this.plans[i], 'status', 'REPLACED')
            }
          }
        }
        this.plans.push(plan)
      }

      this.plan = JSON.parse(JSON.stringify(plan))
    },
    updatePlanStatus(plan) {
      let exists = null
      for(let i = 0; i < this.plans.length; i++) {
        if(this.plans[i].id == plan.id) {
          exists = i
          break
        }
      }
      if(exists !== null) this.$set(this.plans[exists],'status', plan.status)
      if(this.plan.id == plan.id) this.$set(this.plan, 'status', plan.status)
    },
    clearActiveStatusOnPlans() {
      this.plans.forEach((p,i) => {
        this.$set(this.plans[i], 'default', 0)
      })
    },
    onPlansAltered() {
      this.getDataFromApi()
    }
  }
}
</script>

<style lang="scss" scoped>
  .infoTable {
    tbody {
      tr {
        td {
          &:first-child {
            width: 130px;
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  .desiredOutcomesTextarea {
    textarea {
      resize: none;
      margin-top: 2px !important;
    }
  }


  /*.theme--light.v-tabs > .v-tabs-bar .v-tab.householdTab.nonProduct:not(.v-tab--active) {
    color: rgba(0,0,0,.34);
    >.v-icon {
      color: rgba(0,0,0,.34);
    }
  }*/
  .householdTab {
    width: 120px;
    position: relative;
    .householdTabText {
      position: absolute;
      top: 70px;
      height: 30px;
      display: flex;
      align-items: center;
    }
    .householdTabIcon {
      position: absolute;
      top: 20px;
    }
  }
  .householdTabButton {
    width: 120px !important;
    height: 120px !important;
    i {
      transform: translateY(-20px);
    }
  }
</style>